
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.563 4.978c-.07-.267-.215-.551-.322-.8C11.96 1.102 9.165 0 6.907 0 3.884 0 .555 2.027.11 6.204v.854c0 .035.012.355.03.515.249 1.991 1.82 4.107 2.993 6.098 1.262 2.133 2.572 4.232 3.87 6.329.8-1.369 1.597-2.756 2.38-4.089.212-.391.46-.782.673-1.156.142-.248.414-.497.538-.728 1.262-2.311 3.294-4.64 3.294-6.934v-.942c0-.248-.308-1.12-.326-1.173zm-6.6 4.284c-.89 0-1.862-.444-2.342-1.67-.071-.196-.065-.587-.065-.623v-.551c0-1.564 1.328-2.276 2.483-2.276 1.422 0 2.522 1.138 2.522 2.56 0 1.423-1.176 2.56-2.599 2.56z","fill":"#000"}})])
          )
        }
      }
    